import React from 'react';

import Link from './link';
import useTranslation from '../../hooks/use_translation';

const Language = () => {
	const { language, languages, originalPath } =
		useTranslation('component_language');

	return (
		<>
			<div className="language-select link-separator d-flex justify-content-center align-items-center">
				{languages.map((key) => (
					<div
						key={key}
						className="language-select-link link-separator-item px-1 d-flex align-items-center"
					>
						<Link
							className={`text-decoration-none xs ${
								language == key ? ' active' : 'text-muted'
							}`}
							language={key}
							to={`${originalPath}`}
						>
							<span className="">{key}</span>
						</Link>
					</div>
				))}
			</div>
		</>
	);
};

export default Language;
